import { render, staticRenderFns } from "./BreakDetails.vue?vue&type=template&id=cb026d64&"
import script from "./BreakDetails.vue?vue&type=script&lang=js&"
export * from "./BreakDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports